
<template lang="pug">
  button.button.button--icon(
    type="button", 
    :class="buttonClass", 
    :disabled="disabled", 
    @click="scrollTo(scrollPosition)"
  )
    span {{ label }}
    icon(v-if="name", :name="name", :size="size")
</template>

<script>
  import Icon from 'scripts/components/basic/Icon.vue'
  import PrimaryButton from 'scripts/components/buttons/PrimaryButton.vue'

  export default {
    extends: PrimaryButton,
    components: { Icon },
    name: 'ScrollButton',
    props: {
      scrollPosition: {
        type: Number,
        default: 300
      },
      name: String,
      size: String,
      flex: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      buttonClass () {
        return {
          'button--flex': this.flex === true
        }
      }
    },
    methods: {
      scrollTo (scrollPosition) {
        window.scroll({
          top: scrollPosition,
          behavior: "smooth"
        });
      }
    },
  }
</script>

<style scoped lang="scss">
</style>